<template>
  <template v-if="display === 'grid'">
    <div class="product">
      <div class="product__preview">

        <div v-if="product.prices.is_active_discount" class="label label--lg label--discount">
          {{ in18['page_discount'] }}
        </div>
        <div v-else-if="product.is_popular" class="label label--lg label--top">
          {{ in18['page_popular'] }}
        </div>
        <div v-else-if="product.is_new" class="label label--lg label--new">
          {{ in18['page_new'] }}
        </div>


        <a @click="handleClick" :href="product.link" :title="product.title">
          <picture>
            <source :srcset="product.image.webp" type="image/webp">
            <img :alt="product.title" :src="product.image.source" class="product__image" loading="lazy">
          </picture>
        </a>
        <div class="product__btns  product__btns--column">
          <add-to-wishlist-button :product-id="product.id" :class-name="'btn--square'" :in18="in18" :is_wishlist_page="is_wishlist_page"/>
          <add-to-compare-list-button :product-id="product.id" :class-name="'btn--square'" :in18="in18"/>
        </div>

      </div>
      <h3 class="product__title">
        <a @click="handleClick" :href="product.link" :title="product.title">{{ product.title }}</a>
      </h3>
      <div :class="product.stock_status_class" class="product__status">
        {{ product.stock_status }}
      </div>
      <product-price :prices="product.prices" class-name="product__price"/>
    </div>
  </template>

  <template v-else>
    <div class="product  product--row">
      <div class="row">
        <div class="col-md-3">
          <a @click="handleClick" :href="product.link" :title="product.title" class="product__preview">
            <div v-if="product.prices.is_active_discount" class="label label--lg label--discount">
              {{ in18['page_discount'] }}
            </div>
            <div v-else-if="product.is_popular" class="label label--lg label--top">
              {{ in18['page_popular'] }}
            </div>
            <div v-else-if="product.is_new" class="label label--lg label--new">
              {{ in18['page_new'] }}
            </div>
            <picture>
              <source :srcset="product.image.webp" type="image/webp">
              <img class="product__image" :alt="product.title" :src="product.image.source" loading="lazy" width="200" height="200">
            </picture>
          </a>
        </div>

        <div class="col-md-9">
          <div class="product__header">
            <h3 class="product__title">
              <a @click="handleClick" :href="product.link" :title="product.title">
                {{ product.title }}
              </a>
            </h3>
            <ul class="product__data">
              <li class="product_data-item">
                {{ in18['page_manufacturer'] }} <span class="text-primary fw-500">{{ product.manufacture.title }}</span>
              </li>
              <li class="product_data-item">
                {{ in18['page_product_code'] }} <span class="fw-500">{{ product.code }}</span>
              </li>
              <li class="product_data-item">
                {{ in18['page_availability'] }}
                <span :class="product.stock_status_class" class="fw-500">
                    {{ product.stock_status }}
                </span>
              </li>
            </ul>
          </div>
          <div class="product__text">
            <p>{{ product.short_description }}</p>
          </div>
          <div class="product__footer ">
            <product-price :prices="product.prices" class-name="product__price"/>
            <div class="product__btns">
              <add-to-wishlist-button :product-id="product.id" :in18="in18" :is_wishlist_page="is_wishlist_page"/>
              <add-to-compare-list-button :product-id="product.id" :in18="in18"/>
            </div>
          </div>
        </div>
      </div><!-- /.row -->
    </div><!-- /.product--row -->
  </template>
</template>

<script>

import AddToWishlistButton from './../product/AddToWishlistButton.vue';
import AddToCompareListButton from './../product/AddToCompareListButton.vue';

export default {
  name:       "ProductItem",
  components: {
    'add-to-wishlist-button':     AddToWishlistButton,
    'add-to-compare-list-button': AddToCompareListButton,
  },
  props:      {
    display: {
      type:    String,
      default: 'grid'
    },
    product: Object,
    is_wishlist_page: {
      type:    Boolean,
      default: false
    },
  },

  data() {
    return {
      in18: window.in18['shop-product-item'],
    }
  },

  methods: {
    handleClick() {
      ga_select_item_event(this.product);
      window.location.href = this.product.link;
    }
  }
}
</script>
